const passwordValidator = require("./lib/password-validator")
const { normalizeVat } = require("./lib/number")

const commitTime = 1793020214
const release = ".v2.1.254"
const renzShopUrl = "https://dev.renzshop.testversion.online/"
/** @type {{[key: string]: any}} */
const placeholder = {
    /**
     * @param {{ number: any; }} o
     */
    Nummer(o) {
        return o.number
    },
    /**
     * @param {{ endCustomerAddress: { name1: any; }; }} o
     */
    Firma(o) {
        return o.endCustomerAddress?.name1
    },
    /**
     * @param {{ endCustomerAddress: { name2: any; }; }} o
     */
    Vorname(o) {
        return o.endCustomerAddress?.name2
    },
    /**
     * @param {{ endCustomerAddress: { name3: any; }; }} o
     */
    Nachname(o) {
        return o.endCustomerAddress?.name3
    },
    /**
     * @param {{ constructionProject: any; }} o
     */
    Bauvorhaben(o) {
        return o.constructionProject
    },
    /**
     * @param {{ commission: any; }} o
     */
    Kommission(o) {
        return o.commission
    },
}
const placeholderKeys = Object.keys(placeholder)
const placeholderRegexp = new RegExp(`\\[(${placeholderKeys.join("|")})\\]`, "g")
/**
 * @param {any} o
 */
function placeholderCallback(o) {
    return function (
        /** @type {any} */ match,
        /** @type {string | number} */ placeholderKey,
        /** @type {any} */ offset,
        /** @type {any} */ str,
        /** @type {any} */ groups
    ) {
        return placeholder[placeholderKey](o || {}) || ""
    }
}

/**
 * @param {string | undefined} str
 * @param {Operation | OperationOut} o
 */
function replacePlaceholder(str, o) {
    return str?.replace(placeholderRegexp, placeholderCallback(o))
}

// @ts-ignore
if (typeof context !== "undefined" && !context.job) {
    context.response.header("x-commit-time", commitTime)
    context.response.header("x-release", release)
}

const updateOperationEndCustomerAddress = (/** @type {OperationOut} */ operation, /** @type {Address} */ form) => {
    // @ts-ignore - wird zeilenweise gefüllt
    if (!operation.endCustomerAddress) operation.endCustomerAddress = {}
    operation.endCustomerAddress.name1 = form?.company?.name
    operation.endCustomerAddress.name2 = form?.person?.firstname
    operation.endCustomerAddress.name3 = form?.person?.lastname

    operation.endCustomerAddress.city = form?.location?.city
    operation.endCustomerAddress.postcode = form?.location?.postcode
    operation.endCustomerAddress.street = `${form?.location?.street} ${form?.location?.houseNumber}`

    operation.endCustomerEmail = form?.contact?.email
    operation.endCustomerPhone = form?.contact?.phone

    operation.endCustomerVAT = normalizeVat(form?.vat)
    operation.endCustomerFullAddress = JSON.parse(JSON.stringify(form))
    return operation
}
/**
 * @typedef {Object} Login
 * @property {Object} account
 * @property {string[]} account.roles
 * @property {string[]} account.permissions
 */

/**
 * @param {JWTLoginClaims | Login} login
 * @returns {boolean}
 */
const isAdmin = (login) => {
    if (!login) return false
    if ("roles" in login) {
        return login.roles.includes("A")
    } else {
        return login.account.roles.includes("A")
    }
}

/**
 * @param {JWTLoginClaims | Login} login
 * @returns {boolean}
 */
const isClerk = (login) => {
    if (!login) return false
    if ("roles" in login) {
        return login.roles.includes("R")
    } else {
        return login.account.roles.includes("R")
    }
}

/**
 * @param {JWTLoginClaims | Login} login
 * @returns {boolean}
 */
const isCustomer = (login) => {
    if (!login) return false
    if ("roles" in login) {
        return login.roles.includes("C")
    } else {
        return login.account.roles.includes("C")
    }
}

/**
 * @param {JWTLoginClaims | Login} login
 * @returns {boolean}
 */
const isManufacturer = (login) => {
    if (!login) return false
    if ("roles" in login) {
        return login.roles.includes("M")
    } else {
        return login.account.roles.includes("M")
    }
}

/**
 * @param {JWTLoginClaims | Login} login
 * @returns {boolean}
 */
const hasTemplatePermission = (login) => {
    if (!login) return false
    if ("permissions" in login) {
        return login.permissions.includes("T")
    } else {
        return login.account.permissions.includes("T")
    }
}

/**
 * @param {JWTLoginClaims | Login} login
 * @returns {boolean}
 */
const hasPriceCalculationPermission = (login) => {
    if (!login) return false
    if ("permissions" in login) {
        return login.permissions.includes("C")
    } else {
        return login.account.permissions.includes("C")
    }
}

/**
 * @param {JWTLoginClaims | Login} login
 * @returns {boolean}
 */
const hasOpOutPermission = (login) => {
    if (!login) return false
    if ("permissions" in login) {
        return login.permissions.includes("O")
    } else {
        return login.account.permissions.includes("O")
    }
}

/**
 * @param {JWTLoginClaims | Login} login
 * @returns {boolean}
 */
const hasOrderPermission = (login) => {
    if (!login) return false
    if ("permissions" in login) {
        return login.permissions.includes("B")
    } else {
        return login.account.permissions.includes("B")
    }
}

/**
 * @param {JWTLoginClaims | Login} login
 * @returns {boolean}
 */
const hasIntegrationLinkPermission = (login) => {
    if (!login) return false
    if ("permissions" in login) {
        return login.permissions.includes("L")
    } else {
        return login.account.permissions.includes("L")
    }
}

/**
 * @param {JWTLoginClaims | Login} login
 * @returns {boolean}
 */
const hasPersonalPermission = (login) => {
    if (!login) return false
    if ("permissions" in login) {
        return login.permissions.includes("P")
    } else {
        return login.account.permissions.includes("P")
    }
}

/**
 * @param {JWTLoginClaims | Login} login
 * @returns {boolean}
 */
const hasAddressPermissions = (login) => {
    if (!login) return false
    // * only two cases where address is needed
    if ("permissions" in login) {
        return login.permissions?.includes("B") || login.permissions?.includes("O")
    } else {
        return login.account.permissions.includes("B") || login.account.permissions.includes("O")
    }
}

/**
 *
 * @param {OperationPosition} p
 * @param {PriceCalculationRule} rule
 * @returns
 */

function calculateAndSetEndCustomerPriceByRule(p, rule) {
    let price = Math.round(p.netPrice * (100 + (rule?.surchargePercent || 0))) / 100
    if (rule?.type === "discount") {
        const discount = (p.retailPrice / 100) * (rule?.discountPercent || 0)
        if (p.retailPrice - discount >= price) {
            price = Math.round(100 * (p.retailPrice - discount)) / 100
        }
    }
    p.endCustomerPrice = price
    return price
}

/**
 * Überprüft, ob ein Objekt den Bedingungen eines Filters entspricht.
 *
 * @param {PriceCalculationExceptionFilter[]} filters - Array von Filterobjekten.
 * @param {OperationPosition} objectToCheck - Objekt, das überprüft werden soll.
 * @param {Operation | OperationOut} operation - Operation, zu der das Objekt gehört.
 * @returns {boolean} - Gibt `true` zurück, wenn das Objekt den Filterbedingungen entspricht, andernfalls `false`.
 */
function applyFilter(filters, objectToCheck, operation) {
    return filters.every((filter) => {
        let attributeValue
        if (filter.attribute === "modelGroup") attributeValue = objectToCheck.modelGroup
        else if (filter.attribute === "productGroup") attributeValue = objectToCheck.productGroup
        else if (filter.attribute === "installationType") attributeValue = objectToCheck.installationType
        else if (filter.attribute === "originType") attributeValue = operation.source
        else if (filter.attribute == "retailPriceTotal") attributeValue = objectToCheck.retailPriceTotal
        else if (filter.attribute == "netPriceTotal") attributeValue = objectToCheck.netPriceTotal
        else if (filter.attribute == "residentialUnitsCountTotal")
            attributeValue = objectToCheck.residentialUnitsCountTotal
        const stringArrayValues = ["productGroup", "modelGroup", "installationType", "originType"]
        switch (filter.operator) {
            case "eq": // gleich
                if (!stringArrayValues.includes(filter.attribute)) return attributeValue === filter.numberValue
                return filter.stringArrayValues.includes(attributeValue?.toString())

            case "ne": // ungleich
                if (!stringArrayValues.includes(filter.attribute)) {
                    return attributeValue !== filter.numberValue
                } else {
                    return !filter.stringArrayValues.includes(attributeValue?.toString())
                }

            case "gt": // größer
                return typeof attributeValue === "number" && attributeValue > filter.numberValue
            case "ge": // größer gleich
                return typeof attributeValue === "number" && attributeValue >= filter.numberValue
            case "lt": // kleiner
                return typeof attributeValue === "number" && attributeValue < filter.numberValue
            case "le": // kleiner gleich
                return typeof attributeValue === "number" && attributeValue <= filter.numberValue
            default:
                return false // Unbekannter Operator
        }
    })
}

/**
 *
 * @param {OperationPosition} p
 * @param {PriceCalculation} pCalc
 * @param {Operation | OperationOut} operation
 */
function setEndCustomerPriceByPCalc(p, pCalc, operation) {
    if (pCalc) {
        if (pCalc.exception) {
            const rules = pCalc.exception.rules
            for (let i = 0; i < rules.length; i++) {
                if (applyFilter(rules[i].filter, p, operation)) {
                    calculateAndSetEndCustomerPriceByRule(p, rules[i])
                    return
                }
            }
        } else {
            // (backwards compatibility)
            for (let i = 0; i < pCalc.ruleBasedCalculation?.length; i++) {
                if (p.installationType == pCalc.ruleBasedCalculation[i].installationType) {
                    calculateAndSetEndCustomerPriceByRule(p, pCalc.ruleBasedCalculation[i])
                    return
                }
            }
        }
        // @ts-ignore (backwards compatibility)
        let calc = pCalc.calculation || pCalc.globalCalculation
        calculateAndSetEndCustomerPriceByRule(p, calc)
    } else {
        // fallback to UVP
        p.endCustomerPrice = p.retailPrice
    }
}

/**
 * validate password complexity
 *
 * @param {string} password
 * @returns {boolean | any[]}
 */
function validatePassword(password) {
    const pwValidator = new passwordValidator()
    pwValidator.is().min(8).has().uppercase().has().lowercase().has().digits().has().symbols()
    return pwValidator.validate(password)
}

module.exports = {
    commitTime,
    release,
    renzShopUrl,
    normalizeVat,
    replacePlaceholder,
    updateOperationEndCustomerAddress,
    isAdmin,
    isClerk,
    isCustomer,
    isManufacturer,
    hasTemplatePermission,
    hasPriceCalculationPermission,
    hasOpOutPermission,
    hasOrderPermission,
    hasIntegrationLinkPermission,
    hasPersonalPermission,
    hasAddressPermissions,
    calculateAndSetEndCustomerPriceByRule,
    setEndCustomerPriceByPCalc,
    validatePassword,
}
